import Vue from 'vue'

export default new Vue()


// import bus from "@/utils/event_bus";
// bus.$emit("event")
// bus.$emit("event", data)
// bus.$on("event", data => this.doThing(data));